import { LocalDate } from 'src/core/common/domain/date/local-date';
import { Task, TaskPrimitives } from 'src/core/master-data/domain/task';
import { UuidGenerator } from 'src/core/common/infrastructure/uuid/uuid-generator';
import { TaskQueueElement } from './task-queue-element';
import { QueueElementError, QueueElementType } from 'src/core/queue/domain/queue-element';

type StopTaskQueueElementPrimitives = {
  id: string;
  created_at: string;
  type: string;
  task: TaskPrimitives;
  operation_status: { isSavedToServer: boolean; isStoppedToServer: boolean };
  errors: Array<QueueElementError>;
};

export class StopTaskQueueElement extends TaskQueueElement {
  constructor(
    id: string,
    createdAt: LocalDate,
    public task: Task,
    public operationStatus: {
      isSavedToServer: boolean;
      isStoppedToServer: boolean;
    },
    public errors: Array<QueueElementError>
  ) {
    super(id, createdAt, QueueElementType.STOP);
    this.label = this.task.subject;
    this.publicId = this.task.id;
  }

  static fromPayload(payload: StopTaskQueueElementPrimitives) {
    return new this(
      payload.id,
      LocalDate.fromIsoString(payload.created_at),
      Task.fromPrimitives(payload.task),
      payload.operation_status,
      payload.errors
    );
  }

  static fromTask(
    task: Task,
    operationStatus: { isSavedToServer: boolean; isStoppedToServer: boolean },
    errors: Array<QueueElementError>
  ) {
    return new this(UuidGenerator.random(), LocalDate.now(), task, operationStatus, errors);
  }

  toPrimitives(): StopTaskQueueElementPrimitives {
    return {
      id: this.id,
      type: this.type,
      created_at: this.createdAt.atom,
      task: this.task.toPrimitives(),
      operation_status: this.operationStatus,
      errors: this.errors,
    };
  }

  update(
    task: Task,
    operationStatus: { isStoppedToServer: boolean; isSavedToServer: boolean },
    errors: Array<QueueElementError>
  ) {
    this.task = task;
    this.operationStatus = operationStatus;
    this.errors = errors;
  }
}
